module.exports = __webpack_public_path__ + "img/product3.cc2e984e.png";